import React, { useEffect, useState } from 'react';

import {
    Box,
    Button,
    Typography,
    Stack,
    Modal,
    IconButton,
    TextField,

    FormControl,
    InputLabel,
    Select,
    MenuItem,

    InputAdornment
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import PaymentIcon from '@mui/icons-material/Payment';

import Form from '../../Common/Form';

export default function MakePaymentModal({ open, onSubmit, onClose, invoice }) {

    const [formData, setFormData] = useState({
        amount: invoice ? invoice.totalOutstandingAmount : 0,
        currency: invoice.currency || '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        console.debug("MakePaymentModal - formData changed:", formData);
    }, [formData]);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: '400px' },
                maxHeight: '90vh',
                overflow: 'auto',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: { xs: 2, sm: 3, md: 4 },
            }}>
                {/* A close button on the top right */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Form
                    resourceName="Payment"
                    apiPath={`/tenants/sales/invoices/${invoice.id}/pay`}
                    formData={formData}
                    requiredFields={[
                        { name: 'amount', label: 'Amount' },
                    ]}
                    submitText='Pay Now'
                    onSubmit={() => { onSubmit(); onClose(); }}
                    onCancel={onClose}
                >

                    <Stack spacing={2}>

                        <FormControl fullWidth>
                            <InputLabel id="payment-method-input-label">Payment method *</InputLabel>
                            <Select
                                labelId="payment-method-input-label"
                                id="payment-method-select"
                                name="paymentMethod"
                                value={formData.paymentMethod || ''}
                                label="Payment method"
                                onChange={handleChange}
                                required
                            >
                                <MenuItem value="CASH">Cash</MenuItem>
                                <MenuItem value="CHEQUE">Cheque</MenuItem>
                                <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            label="Amount *"
                            name="amount"
                            type='number'
                            placeholder='0.00'
                            value={formData.amount || ''}
                            onChange={handleChange}
                            fullWidth

                            // The InputProps with uppercase I is for MUI TextField component
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <span style={{ color: "#666", userSelect: "none" }}>
                                            {invoice.currency}
                                        </span>
                                    </InputAdornment>
                                ),
                            }}


                            // for inputProps with lowercase i is for the native input element
                            inputProps={{
                                min: 0,
                                step: "0.01",
                                onWheel: (e) => e.currentTarget.blur(), // Prevent changing number input on wheel/scroll    
                            }}
                            required
                        />

                        {formData.paymentMethod === 'CHEQUE' && (
                            <TextField
                                label="Cheque reference number"
                                name="externalReferenceId"
                                value={formData.externalReferenceId || ''}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        )}

                        {formData.paymentMethod === 'BANK_TRANSFER' && (
                            <TextField
                                label="Transaction reference number"
                                name="externalReferenceId"
                                value={formData.externalReferenceId || ''}
                                onChange={handleChange}
                                fullWidth
                                required
                            />
                        )}

                        <TextField
                            label="Notes"
                            name="notes"
                            value={formData.notes || ''}
                            onChange={handleChange}
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </Stack>

                </Form>
            </Box>
        </Modal>
    )
}